import useCrud from '../useCrud'
import useInvalidateQueries from '../useInvalidateQueries'

const useOfficeHour = institutionId => {
  const { findById, update } = useCrud('/admin/v1/office_hours')

  const invalidateQueries = useInvalidateQueries()

  const getOfficeHour = () => findById(['office_hour', institutionId], {}, { enabled: Boolean(institutionId) })

  const { mutateAsync: updateOfficeHour } = update()

  const invalidateOfficeHour = () => invalidateQueries(['office_hour', institutionId])

  return { getOfficeHour, updateOfficeHour, invalidateOfficeHour }
}

export default useOfficeHour
